import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCalendar, FaUser, FaClock, FaArrowRight, FaBook } from 'react-icons/fa';
import '../../../assets/css/student/blogs/BlogPage.css';

const BlogsPage = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const blogs = [
    {
      id: 1,
      title: "Breaking Barriers: How Education Changed Maria's Life",
      excerpt: "Discover how a young student from rural Pakistan overcame financial challenges to pursue her dreams of becoming a doctor.",
      image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80",
      author: "Sarah Ahmed",
      date: "January 15, 2026",
      readTime: "5 min read",
      category: "Success Stories"
    },
    {
      id: 2,
      title: "The Power of Community: Donors Making a Difference",
      excerpt: "Learn about the incredible impact donors have made in transforming the lives of over 1000 students across the country.",
      image: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&q=80",
      author: "Ahmed Khan",
      date: "January 12, 2026",
      readTime: "7 min read",
      category: "Impact"
    },
    {
      id: 3,
      title: "Transparency in Action: How We Track Every Donation",
      excerpt: "A deep dive into our transparent donation tracking system and how we ensure every rupee reaches deserving students.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
      author: "Fatima Raza",
      date: "January 10, 2026",
      readTime: "6 min read",
      category: "Transparency"
    },
    {
      id: 4,
      title: "From Student to Engineer: Ali's Inspiring Journey",
      excerpt: "Follow Ali's remarkable transformation from a struggling student to a successful software engineer giving back to his community.",
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80",
      author: "Zainab Hassan",
      date: "January 8, 2026",
      readTime: "8 min read",
      category: "Success Stories"
    },
    {
      id: 5,
      title: "The NGO Partnership Model: Building Trust Together",
      excerpt: "How we work with verified NGOs to ensure genuine cases receive support and maintain accountability at every step.",
      image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=80",
      author: "Usman Malik",
      date: "January 5, 2026",
      readTime: "5 min read",
      category: "Partnerships"
    },
    {
      id: 6,
      title: "Education in Crisis: How You Can Help",
      excerpt: "Understanding the education crisis in Pakistan and practical ways you can contribute to making a lasting difference.",
      image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&q=80",
      author: "Ayesha Ali",
      date: "January 3, 2026",
      readTime: "6 min read",
      category: "Awareness"
    }
  ];

  return (
    <div className="blogs-page">
      {/* Header Section */}
      <div className="blogs-header">
        <div className="blogs-header-content">
          <Link to="/" className="back-link">
            <FaArrowLeft /> Back to Home
          </Link>
          
          <div className="blogs-header-icon">
            <FaBook />
          </div>
          
          <h1 className="blogs-main-title">Our Blogs</h1>
          <p className="blogs-main-subtitle">
            Read inspiring stories, insights, and updates about our mission to
            empower education through transparency and community support.
          </p>
        </div>
      </div>

      {/* Blogs Grid */}
      <div className="blogs-container">
        <div className="blogs-grid">
          {blogs.map((blog) => (
            <article
              key={blog.id}
              className={`blog-card ${hoveredCard === blog.id ? 'hovered' : ''}`}
              onMouseEnter={() => setHoveredCard(blog.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* Image Container */}
              <div className="blog-image-container">
                <img 
                  src={blog.image} 
                  alt={blog.title}
                  className="blog-image"
                  loading="lazy"
                />
                <div className="blog-image-overlay">
                  <span className="blog-category">{blog.category}</span>
                </div>
              </div>

              {/* Content */}
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-meta-item">
                    <FaUser /> {blog.author}
                  </span>
                  <span className="blog-meta-item">
                    <FaCalendar /> {blog.date}
                  </span>
                  <span className="blog-meta-item">
                    <FaClock /> {blog.readTime}
                  </span>
                </div>

                <h2 className="blog-title">{blog.title}</h2>
                <p className="blog-excerpt">{blog.excerpt}</p>

                <Link to={`/blogs/${blog.id}`} className="blog-read-more">
                  Read More <FaArrowRight className="arrow-icon" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogsPage;